// extracted by mini-css-extract-plugin
export default {"container":"PinnedIssues-module__container--qvnXj","area":"PinnedIssues-module__area--pgH8Q"};